module.exports = __webpack_public_path__ + "img/Spatulas-min.10de7b97.png";